import axios from "axios";

export default axios.create({
  baseURL: process.env.VUE_APP_RADAR_GRID_ENDPOINT,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  responseType: "json",
});
